
import { Component, Vue, Watch, Prop, Emit } from "vue-property-decorator"
import { namespace, Getter, Action } from "vuex-class"

import vSelect from "vue-select"
import UserSelect from "@/components/Controls/UserSelect.vue"
import DeleteButton from "@/components/Controls/DeleteButton.vue"

import { Recipient, RecipientType, RecipientTypeLabels, Team } from "@/types"

import Guid from "@/scripts/guid"
import { Field } from "@/types/Field"
import { CaseColumn } from "@/types/caseColumns"
import ValidationMixin from "@/mixins/validationMixin"
import { mixins } from "vue-class-component"

const setup = namespace("setup")

@Component({
	components: {
		"v-select": vSelect,
		"user-select": UserSelect,
		"btn-delete": DeleteButton
	}
})

export default class RecipientList extends mixins(ValidationMixin) {
	@Prop({ required: true })
	value!: Recipient[] | null

	@Prop({ default: () => [] })
	teams!: Team[]

	@Prop({ default: () => [] })
	fields!: CaseColumn[]

	@Prop({ type: Boolean, default: false })
	allowEmailAddress!: boolean

	@Prop({ type: Boolean, default: false })
	excludeUsers!: boolean

	@Prop({ type: String, default: null })
	dropDirection!: "up" | "down" | "left" | "right" | null

	recipientType = RecipientType
	recipientTypeByKey = RecipientTypeLabels.toDictionary("key")

	private get userRoleFields (): CaseColumn[] {
		return this.fields.filter(f => f.dataType === "user-role")
	}

	private get optionText (): string {
		return this.excludeUsers ? "Exclude" : "Send to"
	}

	private get dropDirectionPropValue (): {} | null {
		if (!this.dropDirection) return {}

		const propValueObject: any = {}
		const propName = `drop${this.dropDirection}`
		propValueObject[propName] = true
		return propValueObject
	}

	private get recipientTypeOptions (): { key: RecipientType, label: string }[] {
		var typeOptions = this.allowEmailAddress ? RecipientTypeLabels : RecipientTypeLabels.filter(t => t.key !== RecipientType.EmailAddress)

		if (this.teams.length === 0) {
			typeOptions = typeOptions.filter(t => t.key !== RecipientType.Team)
		}

		if (this.userRoleFields.length === 0) {
			typeOptions = typeOptions.filter(t => t.key !== RecipientType.UserRole)
		}

		return typeOptions
	}

	private add (type: RecipientType) {
		this.$emit("input", [
			...(this.value || []),
			{
				key: Guid.newGuid(),
				type
			}
		])
	}

	private remove (item: Recipient) {
		if (!this.value) return
		this.$emit("input", this.value.filter(i => i.key !== item.key))
	}

	private setId (item: Recipient, id: string) {
		Vue.set(item, "id", id)
		this.$emit("input", this.value)
	}

	private setValue (item: Recipient, property: string, value: string) {
		Vue.set(item, property, value)
		this.$emit("input", this.value)
	}
}

